if (!customElements.get('image-tabs')) {
  class ImageTabs extends HTMLElement {
    constructor() {
      super();
      this.tabItems = this.querySelectorAll('.--img-tab-item');
      this.tabContents = this.querySelectorAll('.--img-tab-content');
      this.hotspots = this.querySelectorAll('.hotspot');
      this.init();
    }

    init() {
      // Set the first tab as active by default
      if (this.tabItems.length > 0) {
        this.tabItems[0].classList.add('--img-is-active');
      }

      this.tabItems.forEach((item) => {
        item.addEventListener('click', this.handleTabClick.bind(this));
      });

      this.prevButton = this.querySelector('.carousel_prev_btn');
      this.nextButton = this.querySelector('.carousel_next_btn');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.handleCarouselClick('prev'));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.handleCarouselClick('next'));
      }

      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('mouseenter', this.handleHotspotEnter.bind(this));
        hotspot.addEventListener('mouseleave', this.handleHotspotLeave.bind(this));
        hotspot.addEventListener('focusin', this.handleHotspotEnter.bind(this));
        hotspot.addEventListener('focusout', this.handleHotspotLeave.bind(this));
      });

      this.updateCarouselButtons();
    }

    handleTabClick(event) {
      const clickedItem = event.currentTarget;
      const tabIndex = parseInt(clickedItem.dataset.tabIndex, 10);

      this.setActiveTab(tabIndex);
    }

    handleCarouselClick(direction) {
      const activeIndex = this.getActiveIndex();
      const targetIndex = direction === 'prev' ? activeIndex - 1 : activeIndex + 1;

      if (targetIndex < 0 || targetIndex >= this.tabItems.length) {
        return;
      }

      this.setActiveTab(targetIndex);
    }

    setActiveTab(index) {
      const tabIndex = Number(index);
      const clickedItem = this.tabItems[tabIndex];
      if (!clickedItem) return;

      clickedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

      this.tabItems.forEach((item) => {
        item.classList.remove('--img-is-active');
        item.setAttribute('aria-selected', 'false');
      });

      clickedItem.classList.add('--img-is-active');
      clickedItem.setAttribute('aria-selected', 'true');

      this.tabContents.forEach((content) => {
        content.style.display = 'none';
      });

      const activeContent = this.querySelector(`.--img-tab-content[data-tab-index="${tabIndex}"]`);
      if (activeContent) {
        activeContent.style.display = 'block';
      }

      this.updateCarouselButtons();
    }

    getActiveIndex() {
      const activeItem = Array.from(this.tabItems).find((item) => item.classList.contains('--img-is-active'));
      return activeItem ? parseInt(activeItem.dataset.tabIndex, 10) : 0;
    }

    updateCarouselButtons() {
      const activeIndex = this.getActiveIndex();
      const lastIndex = this.tabItems.length - 1;

      if (this.prevButton) {
        const hasPrev = activeIndex > 0;
        this.prevButton.classList.toggle('disabled', !hasPrev);
        this.prevButton.disabled = !hasPrev;
        this.prevButton.setAttribute('aria-disabled', String(!hasPrev));
      }

      if (this.nextButton) {
        const hasNext = activeIndex < lastIndex;
        this.nextButton.classList.toggle('disabled', !hasNext);
        this.nextButton.disabled = !hasNext;
        this.nextButton.setAttribute('aria-disabled', String(!hasNext));
      }
    }

    handleHotspotEnter(event) {
      const hotspot = event.currentTarget;
      hotspot.classList.add('is-active');
      const button = hotspot.querySelector('.hotspot__btn');
      const card = hotspot.querySelector('.hotspot__card');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (card) card.setAttribute('aria-hidden', 'false');
    }

    handleHotspotLeave(event) {
      const hotspot = event.currentTarget;
      hotspot.classList.remove('is-active');
      const button = hotspot.querySelector('.hotspot__btn');
      const card = hotspot.querySelector('.hotspot__card');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (card) card.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('image-tabs', ImageTabs);
}